export interface Size {
  width: number;
  height: number;
}

export interface Point {
  x: number;
  y: number;
}

/**
 * Bound a canvas pan offset to the artwork's own overflow.
 *
 * Pan used to be unbounded — the stage wrote the raw mouse delta straight into
 * its transform, so one drag could throw the artwork completely off-screen with
 * no affordance to get it back. The bound is how much of the SCALED artwork does
 * not fit its column, which is the rule every image viewer uses: you can reach
 * any edge and you can never leave the picture. At or below fit there is no
 * overflow, so there is no pan.
 */
export function clampPan(pan: Point, box: Size, container: Size, zoom: number): Point {
  const maxX = Math.max(0, (box.width * zoom - container.width) / 2);
  const maxY = Math.max(0, (box.height * zoom - container.height) / 2);
  // `|| 0` collapses -0. Clamping a negative pan against a zero bound yields -0,
  // which renders identically but is not `Object.is`-equal to 0, so it would make
  // an "is the view at rest?" comparison lie.
  return {
    x: Math.min(Math.max(pan.x, -maxX), maxX) || 0,
    y: Math.min(Math.max(pan.y, -maxY), maxY) || 0,
  };
}
